const state = {
  tankId: 0,
}

const getters = {
  getTankInfo(state) {
    return state;
  },
}

const mutations = {
  SET_TANK_INFO(state, tankId) {
    state.tankId = tankId;
  },
}

const actions = {
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
